import React, { useState } from 'react';
import { useToolbarOverflowMenuClose } from './Toolbar';
import { MenuItem } from '../../../components/Menu';
import downloadAllIcon from '../../../icons/non-prefilled/16x16/downloadAll.svg';

interface DownloadAllMenuItemProps {
  handleDownloadAll: () => Promise<void>;
}

const DownloadAllMenuItem = ({
  handleDownloadAll,
}: DownloadAllMenuItemProps) => {
  const [isPreparing, setIsPreparing] = useState(false);
  const closeOverflowMenu = useToolbarOverflowMenuClose();

  return (
    <MenuItem
      icon={downloadAllIcon}
      onClick={() => {
        setIsPreparing(true);
        handleDownloadAll().finally(() => {
          setIsPreparing(false);
          closeOverflowMenu();
        });
      }}
    >
      {isPreparing ? 'Preparing...' : 'Download all (zip)'}
    </MenuItem>
  );
};

export default DownloadAllMenuItem;
